import GoogleOAuth2 from 'google-oauth2-web-client';
import {bcTypes} from 'bc/services/bcTypes';
import {get} from 'lodash';

export const doGadsAuthFlow = (clientId, createDataSource, me) => {
  let locOrigin = window.location.origin;
  if (locOrigin.indexOf('localhost:') === -1) {
    const baseDnsName = me.baseDNSName === 'anodot-test.com' ? 'ano-dev.com' : me.baseDNSName;
    locOrigin = `https://${me.clusterDNSPrefix}.${baseDnsName}`;
  }

  const go2 = new GoogleOAuth2({
    clientId,
    redirectUri: `${locOrigin}/api/v1/bc/signin/oauth/google/callback`,
    scope:
      // eslint-disable-next-line max-len
      'https://www.googleapis.com/auth/adwords',
    responseType: 'code',
    accessType: 'offline',
    state: me.ownerOrganization || 'no-org-id',
    popupHeight: 600,
    popupWidth: 600,
  });
  go2.login(true, false);

  window.createDataSource = function(token) {
    createDataSource({
      code: token,
      type: bcTypes.google_ads.type,
      name: `Google Ads Data Source ${new Date().getTime().toString()}`,
      authenticationType: 'refresh_token',
      redirectURI: `${locOrigin}/api/v1/bc/signin/oauth/google/callback`,
    });
  };
};

export const getEditorValidationMessage = (stream) => {
  if (!stream.clientCustomerId) {
    return 'Google Adwords account is mandatory';
  }
  if (!stream.reportType) {
    return 'Google Adwords use case is mandatory';
  }
  if (!get(stream, 'metrics.length')) {
    return 'Data stream should have at least one metric';
  }
  if (get(stream, 'uiState.timeZoneError')) {
    return 'The selected Google Ads accounts must use the same timezone';
  }
  if (stream.delayMinutes > 720) {
    return 'Maximum delay is 12 hours';
  }

  return null;
};
